module.exports = __webpack_public_path__ + "by.851744c8d55f3a47daa5.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/by.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/by.svg
// module chunks = styles